import React, { useState } from "react";
import PropTypes from "prop-types";
import { Frame } from "@bitesite/react-figstrap";
import SquareCardsList from "../../square_cards/square_cards_list";
import AddSquareCardModal from "../../square_cards/add_square_card_modal";

const SquareCardSelection = ({ onSelectedSquareCardChange, theme }) => {
  const [squareCardsListKey, setSquareCardsListKey] = useState(0);

  return (
    <Frame vertical gap={10}>
      <div>Which credit card would you like to use?</div>
      <div>
        <SquareCardsList
          key={squareCardsListKey}
          theme={theme}
          selectable
          onChange={(newSelectedSquareCard) =>
            onSelectedSquareCardChange(newSelectedSquareCard)
          }
        />
      </div>
      <div>
        <AddSquareCardModal
          onSquareCardFormSuccess={() => {
            setSquareCardsListKey((prevValue) => prevValue + 1);
          }}
          theme={theme}
        />
      </div>
    </Frame>
  );
};

SquareCardSelection.propTypes = {
  onSelectedSquareCardChange: PropTypes.func.isRequired,
  theme: PropTypes.string,
};

export default SquareCardSelection;
